module.exports = __webpack_public_path__ + "img/userRes_e.ed37fa80.png";